import { Order } from 'blockly/lua'
import { BlockDefinition, numberOutput } from './common'

export const sensingDefaults: Partial<BlockDefinition> = {
  style: 'sensing',
}

export const sensingBlocks: Array<BlockDefinition> = [
  {
    opcode: 'sensing_timer',
    ...numberOutput,
    generator: () => ['time()', Order.HIGH],
    message0: '%{BKY_B_TIMER}',
  },
]
